import { render } from "./InsertMoveVouchers.vue?vue&type=template&id=2875e9bf"
import script from "./InsertMoveVouchers.vue?vue&type=script&lang=js"
export * from "./InsertMoveVouchers.vue?vue&type=script&lang=js"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__